import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const recycleIcon = svgToTinyDataUri(
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
  <path d="M12 2L7.5 9H2L7 17L4 22H20L17 17L22 9H16.5L12 2Z" fill="#A6CE39"/>
  <path d="M12 4.5L8.5 10H5L8.5 15.5L6.5 20H17.5L15.5 15.5L19 10H15.5L12 4.5Z" fill="#8AB62D"/>
  <path d="M9.5 12L12 8L14.5 12H13V16H11V12H9.5Z" fill="white"/>
  <path d="M7 17L9 14H8L10 11L8 11L11 7" stroke="white" stroke-width="0.5" fill="none"/>
  <path d="M17 17L15 14H16L14 11L16 11L13 7" stroke="white" stroke-width="0.5" fill="none"/>
</svg>`
);
